import { render, staticRenderFns } from "./ListEducationalPost.vue?vue&type=template&id=7ef0ea8f&scoped=true&"
import script from "./ListEducationalPost.vue?vue&type=script&lang=js&"
export * from "./ListEducationalPost.vue?vue&type=script&lang=js&"
import style0 from "./ListEducationalPost.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ListEducationalPost.vue?vue&type=style&index=1&id=7ef0ea8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0ea8f",
  null
  
)

export default component.exports